import { AppType } from '../../constants/AppType';
import Applications from '../../components/Applications/Applications';
import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';

const LinuxServices = withHasPermission(() => {
    return <Applications type={AppType.LinuxService} title={'Linux Services'} icon={'fa fa-cog'} />;
}, Permission.Root_LinuxServices);

export default LinuxServices;
